import { toCalendarDateFormat, toDate } from 'lib/utils';
import { Container } from '@qga/roo-ui/components';
import useDetailsBooking from 'hooks/useDetailsBooking';
import useNavigateTo from 'hooks/useNavigateTo';
import { useChangeDates } from '../ChangeDatesProvider';
import useAvailabilityCalendar from '../ChangeDatesProvider/lib/useAvailabilityCalendar';
import { InPathFlightBookingAlert } from 'components/InPathFlightBookingAlert';
import DatesForm from './DatesForm';
import * as codes from '../ChangeDatesProvider/lib/errorCodes';

const DateFormContainer = () => {
  const { booking } = useDetailsBooking();
  const { startDate, endDate, stage, handleQuote, errorCode } = useChangeDates();
  const { loading, minDate, maxDate, blockedDates } = useAvailabilityCalendar();

  const navigateTo = useNavigateTo();
  const isUnavailable = errorCode === codes.INVENTORY_UNAVAILABLE;

  const searchedDates = {
    checkIn: toCalendarDateFormat(startDate),
    checkOut: toCalendarDateFormat(endDate),
  };

  return (
    <>
      <Container pt={12} pb={0}>
        <InPathFlightBookingAlert m={0} />
      </Container>
      <DatesForm
        initialValues={searchedDates}
        originalValues={{ checkIn: booking.reservation.checkIn, checkOut: booking.reservation.checkOut }}
        unavailableValues={isUnavailable ? searchedDates : undefined}
        blockedDates={blockedDates}
        minDate={minDate}
        maxDate={maxDate}
        loading={stage === 'QUOTING' || loading}
        onClickBack={() => navigateTo.booking('replace', booking.id)}
        onSubmit={(values) =>
          handleQuote({
            startDate: toDate(values.checkIn),
            endDate: toDate(values.checkOut),
          })
        }
      />
    </>
  );
};

export default DateFormContainer;
